import { render } from "./View.vue?vue&type=template&id=0f276c72"
import script from "./View.vue?vue&type=script&lang=js"
export * from "./View.vue?vue&type=script&lang=js"
script.render = render

export default script